export default "__VITE_PUBLIC_ASSET__16292d7b__"